import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { editEmployee } from '../actions/SearchActionCreators';
import EmployeeResult from './EmployeeResult';
import BranchResult from './BranchResult';
import { login } from '../actions/SearchActionCreators';
import FontAwesome from 'react-fontawesome';
import { FormattedMessage } from 'react-intl';
import MessageDefinitions from '../i18n/MessageDefinitions';

@connectToStores(['LoginStore'], (context, props) => {
  const LoginStore = context.getStore('LoginStore');

  return {
    employee: LoginStore.getSelectedEmployee(),
    processing: LoginStore.isProcessing()
  };
})
class Results extends Component {
  static propTypes = {
    employee: PropTypes.object.isRequired,
    processing: PropTypes.bool.isRequired
  };
  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.loginClicked = this.loginClicked.bind(this);
    this.editClicked = this.editClicked.bind(this);

    const state = {};
    if (props.employee && props.employee.branches && props.employee.branches.length === 1) {
      state.selectedBranch = props.employee.branches[0];
    }

    this.state = state;
  }

  loginClicked() {
    this.context.executeAction(login, {
      employee: this.props.employee,
      branch: this.state.selectedBranch
    });
  }

  editClicked() {
    this.context.executeAction(editEmployee, this.props.employee);
  }

  render() {
    const { employee, processing } = this.props;
    const { selectedBranch } = this.state;

    const loginDisabled = selectedBranch ? false : true;

    const selectedBranchMessage = selectedBranch ? null : <FormattedMessage {...MessageDefinitions.branchesSelect}/>;

    const branchComponents = (employee.branches || []).map(branch => {
      const branchClicked = () => {
        this.setState({
          selectedBranch: branch
        });
      };

      const selected = selectedBranch && selectedBranch.id === branch.id;

      const className = selected ? 'selected' : '';

      const children = selected ? <FontAwesome name="check"/> : null;

      return <BranchResult key={branch.id} className={className} onClick={branchClicked} branch={branch}>
        {children}
      </BranchResult>;
    });

    const buttonMessage =
      processing
        ? <FontAwesome name="refresh" spin/>
        : <FormattedMessage {...MessageDefinitions.login}/>;

    return <div className="employee-login-selected">
      <div className="form-body">
        <EmployeeResult employee={employee}/>
        <div className="branch-list">
          {branchComponents}
        </div>
        <div className="branch-select-message">
          {selectedBranchMessage}
        </div>
      </div>
      <div className="form-actions">
        <button onClick={this.editClicked} className="btn btn-primary edit" disabled={processing}>
          <FormattedMessage {...MessageDefinitions.edit}/>
        </button>
        <button onClick={ this.loginClicked} className="btn btn-primary login" disabled={loginDisabled || processing}>
          {buttonMessage}
        </button>
      </div>
    </div>;
  }
}

export default Results;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/Login.js
 **/